import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { User, Lock, Loader2 } from "lucide-react";
import { mainRouteInitial } from "../../Data/Constant";
import bgImage from "../../Assets/bg.png";
import "./index.css";

const STATIC_USERNAME = "varanasi";
const STATIC_PASSWORD = "varanasi@#2026";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = Cookies.get("isLoggedIn") || localStorage.getItem("isLoggedIn");
    if (isLoggedIn === "true") {
      // navigate(`/${mainRouteInitial}/Dashboard`, { replace: true });
      navigate(`/${mainRouteInitial}/VidhanSabhaDashboard`, { replace: true });
    }
  }, [navigate]);

  const handleLogin = (e) => {
    e.preventDefault();
    setErrorMessage("");

    const trimmedUsername = username.trim();
    const trimmedPassword = password.trim();

    if (!trimmedUsername) {
      setErrorMessage("Please enter username.");
      return;
    }

    if (!trimmedPassword) {
      setErrorMessage("Please enter password.");
      return;
    }

    if (trimmedUsername !== STATIC_USERNAME || trimmedPassword !== STATIC_PASSWORD) {
      setErrorMessage("Invalid Username or Password!");
      return;
    }

    setIsLoading(true);

    setTimeout(() => {
      // Set session cookies / local storage
      Cookies.set("isLoggedIn", "true");
      Cookies.set("Narendra_Modi_UserName", "varanasi");
      Cookies.set("Narendra_Modi_LoginFrom", "Web");
      localStorage.setItem("isLoggedIn", "true");

      setIsLoading(false);
      navigate(`/${mainRouteInitial}/VidhanSabhaDashboard`, { replace: true });
    }, 400);
  };

  return (
    <div className="harsh-login-wrapper">
      {/* Animated Scrolling Background */}
      <div className="harsh-bg-container">
        <div className="harsh-scrolling-bg" style={{ backgroundImage: `url(${bgImage})` }} />
        <div className="harsh-bg-overlay" />
      </div>

      {/* Top Header Title */}
      <div className="harsh-login-header">
        <h1 className="harsh-login-title">NARENDRA MODI</h1>
      </div>

      {/* Glassmorphic Login Card */}
      <div className="harsh-login-card-container">
        <div className="harsh-login-card">
          {/* Circular Glowing Emblem / Ring */}
          <div className="harsh-emblem-wrapper">
            <div className="harsh-emblem-ring" />
            <div className="harsh-emblem-inner">
              <User size={24} color="#ffffff" />
            </div>
          </div>

          {/* Form */}
          <form className="harsh-login-form" onSubmit={handleLogin}>
            {errorMessage && (
              <div className="harsh-error-alert" role="alert">
                {errorMessage}
              </div>
            )}

            {/* Username Input */}
            <div className="harsh-input-wrapper">
              <span className="harsh-input-icon">
                <User size={18} />
              </span>
              <input
                type="text"
                className="harsh-input-field"
                placeholder="Username.."
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  if (errorMessage) setErrorMessage("");
                }}
                autoFocus
              />
            </div>

            {/* Password Input */}
            <div className="harsh-input-wrapper">
              <span className="harsh-input-icon">
                <Lock size={18} />
              </span>
              <input
                type="password"
                className="harsh-input-field"
                placeholder="Password.."
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (errorMessage) setErrorMessage("");
                }}
              />
            </div>

            <button type="submit" className="harsh-login-btn" disabled={isLoading}>
              {isLoading ? (
                <>
                  <Loader2 size={18} className="animate-spin" />
                  LOGGING IN...
                </>
              ) : (
                "LOG IN"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
